import { showErrorMessage, showSuccessMessage } from 'components/Helpers/Toasts';
import { getUserFriendlyErrors } from 'connectors/lib/friendlyErrorMessageParser';
import { useRemovePromoCodeFromCartMutationApi } from 'graphql/generated';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { usePersistStore } from 'store/usePersistStore';

export const useRemovePromoCodeFromCart = (): [typeof removePromoCodeHandler, boolean] => {
    const [{ fetching }, removePromoCode] = useRemovePromoCodeFromCartMutationApi();
    const { cartUuid, defaultStoreUuid } = usePersistStore((s) => s);
    const t = useTypedTranslationFunction();

    const removePromoCodeHandler = (
        promoCodesToBeRemoved: string[],
        messages: { success: string; error: string },
        onSuccess?: () => void,
    ) => {
        promoCodesToBeRemoved.forEach(async (promoCodeToBeRemoved) => {
            const removePromoCodeResult = await removePromoCode({
                input: { promoCode: promoCodeToBeRemoved, cartUuid },
                defaultStoreUuid,
                selectedStoreUuid: null,
            });

            // EXTEND PROMO CODE MODIFICATIONS HERE
            if (removePromoCodeResult.error !== undefined) {
                const { userError } = getUserFriendlyErrors(removePromoCodeResult.error, t);
                if (userError?.validation?.promoCode !== undefined) {
                    showErrorMessage(userError.validation.promoCode.message, 'cart');
                } else {
                    showErrorMessage(messages.error, 'cart');
                }
            }

            if (onSuccess) {
                onSuccess();
            }
            showSuccessMessage(messages.success);
        });
    };

    return [removePromoCodeHandler, fetching];
};
